import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-restaurant-menu-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './restaurant-menu-widget.component.html',
  styleUrls: ['./restaurant-menu-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestaurantMenuWidgetComponent {}
